// @ts-nocheck
import { Columns } from '../../../table/table.model';

export const tableHeader: Array<Columns> = [
  {
    name: 'id',
    type: 'data',
    label: 'Tipo de Solicitação',
    col: 3,
    enableCopy: false,
  },
  // {
  //   name: 'financialCode',
  //   type: 'data',
  //   label: 'Linha Digitável',
  //   col: 3,
  //   enableCopy: false,
  // },
  {
    name: 'dateReference',
    type: 'data',
    label: 'Data de Referência',
    col: 3,
    enableCopy: false,
  },
  {
    name: 'primaryValue',
    type: 'data',
    label: 'Valor',
    col: 3,
    enableCopy: false,
  },
  {
    name: 'primaryValueUS',
    type: 'data',
    label: 'Valor em Dólar',
    col: 3,
    enableCopy: false,
  },
  {
    name: 'endValue',
    type: 'data',
    label: 'Valor Atualizado',
    col: 3,
    enableCopy: false,
  },
];
